import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AccountAddressEditComponentDef } from '@df/account/account-address-edit.component.def';
import { IRequestCallback, ISubmitFormOptions } from '@df/api/request/request.service';
import { Client } from '@df/core/service/client';
import { Status } from '@df/core/status';
import { AddressBook } from '@df/session/api/address-book/address-book';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Subject } from 'rxjs';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { ActionInlineComponent } from '../../../ui/display/action-inline/action-inline.component';
import { CheckboxComponent } from '../../../ui/form/checkbox';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { AccountBackComponent } from '../../back/account-back.component';
import { AccountFormComponent } from '../../form/account-form.component';
import { AccountAddressFieldsetComponent } from '../fieldset/account-address-fieldset.component';
import { AccountViewComponent } from './../../view/account-view.component';
@Component({
    selector: 'account-address-edit',
    templateUrl: './account-address-edit.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ActionComponent,
        AccountAddressFieldsetComponent,
        ResultComponent,
        FormsModule,
        InputWrapComponent,
        AccountBackComponent,
        AccountFormComponent,
        CommonModule,
        TranslationModule,
        ActionInlineComponent,
        IfSizeDirective,
        CheckboxComponent
    ]
})
export class AccountAddressEditComponent extends AccountAddressEditComponentDef implements OnDestroy {
    submitSubject = new Subject<boolean>();
    removeStatus = new Status();
    readonly backLink = '/account/address-book';
    constructor(
        activatedRoute: ActivatedRoute,
        ref: ChangeDetectorRef,
        addressBook: AddressBook,
        private accountViewComponent: AccountViewComponent,
        private client: Client,
        @Optional()
        private modalRef: ModalRef<AccountAddressEditComponent>
    ) {
        super(activatedRoute, ref, addressBook);
        accountViewComponent.forceContentCols = 5;
    }
    close(): void {
        if (this.modalRef) {
            this.modalRef.close();
        } else {
            this.router.navigateByUrl(this.backLink);
        }
    }
    onSubmitSuccess() {
        this.close();
        super.onSubmitSuccess();
    }
    ngOnDestroy(): void {
        this.accountViewComponent.forceContentCols = undefined;
        super.ngOnDestroy();
    }
    delete() {
        this.model.remove(this.removeStatus, () => this.close());
    }
    submit(onSuccess: IRequestCallback = [], onError?: IRequestCallback): void {
        this.submitSubject.next(true);
        super.submit(onSuccess, onError);
    }
    get submitFormOptions(): ISubmitFormOptions {
        const offset = this.client.isX || this.client.isL ? 150 : 70;
        return { errorScrollContainer: this.formRef?.nativeElement, errorScrollOptions: { offset } };
    }
}
